var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('div',{staticClass:"messages-page page w-100 p-0 m-0"},[_c('div',{staticClass:"page__header"},[_c('h2',[_vm._v("My Messages")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }